import { SVGProps } from 'react';

const SvgArrowUp = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 6" {...props}>
        <path d="m10 5.5-5-5-5 5h10Z" />
    </svg>
);
export default SvgArrowUp;
